import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockCheckHistoryAction } from './stock-check-history.actions';
import { StockCheckHistoryService } from '../../service/stock-check-history.service';

@Injectable()
export class StockCheckHistoryEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: StockCheckHistoryService
  ) {}

  loadStockCheckHistoryListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockCheckHistoryAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Stock Count History List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        console.log(action.criteriaObj);
        return this.service.getStockCheckHistoryList(action.criteriaObj).pipe(
          map((data: any) => StockCheckHistoryAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
